export interface ToastPayloadMap {
  boardInvites: { boardUid: string; ownerUid: string; boardTitle: string; inviteCount: number }
  encryptionNotice: { sessionUid: string; boardUid: string }
  notice: { i18nKey: string; variant?: "success" | "info" | "warning" | "danger"; icon?: string; reference?: string }
  featureFlagOverrides: { overrides: Record<string, boolean> }
}

export type ToastKind = keyof ToastPayloadMap

export type ToastData = { [K in ToastKind]: { kind: K; id: string } & ToastPayloadMap[K] }[ToastKind]

export function toast<K extends ToastKind>(kind: K, payload: ToastPayloadMap[K], id: string): ToastData {
  return { kind, id, ...payload } as ToastData;
}
